<template>
  <e-dialog v-model="isOpened">
    <template #title>
      <div class="caption">Новая группа услуг</div>
    </template>
    <service-group-form
      :tariff-schedule-cid="tariffScheduleCid"
      :hotel-set-cid="hotelSetCid"
      :show-confirmation="showConfirmation"
      @success:add="onServiceGroupSubmit"
      @cancel="closeDialog"
    />
  </e-dialog>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core';
import type { AddServiceGroupPayload } from '@/parts/tariffs/store/serviceGroups';
import EDialog from '@/core/components/modals/Dialog.vue';
import ServiceGroupForm from '@/parts/tariffs/components/ServiceGroupForm.vue';

const props = defineProps<{
  tariffScheduleCid?: string;
  hotelSetCid: string;
  modelValue?: boolean;
  showConfirmation?: boolean;
}>();

const emit = defineEmits<{
  (event: 'success', data: AddServiceGroupPayload): void;
}>();

const isOpened = useVModel(props, 'modelValue');

const onServiceGroupSubmit = (data: AddServiceGroupPayload) => {
  emit('success', data);

  isOpened.value = false;
};

const closeDialog = () => {
  isOpened.value = false;
};
</script>

<style scoped lang="scss"></style>
